import React, { useState } from "react";
import PropTypes from "prop-types";
import { 
    NeoModal, 
    NeoInput, 
    NeoButton 
} from "../../../../components/Common";

/**
 * TransferModal
 * Modal premium para selecionar o colaborador destino da transferência de carteira.
 * Migrado 100% para o Neo Design System com zero estilos inline.
 */
const TransferModal = ({
    isOpen,
    toggle,
    employees,
    currentEmployeeId,
    selectedCount,
    onConfirm,
    isTransferring
}) => {
    const [targetEmployeeId, setTargetEmployeeId] = useState("");

    // Filtrar o employee atual da lista de destinos
    const availableEmployees = employees.filter(e => e.id !== currentEmployeeId);

    const handleConfirm = () => {
        if (!targetEmployeeId) return;
        onConfirm(targetEmployeeId);
    };

    const handleClosed = () => {
        setTargetEmployeeId("");
    };

    return (
        <NeoModal
            isOpen={isOpen}
            toggle={toggle}
            centered
            onClosed={handleClosed}
            title="Transferir Clientes"
            subtitle="Selecione o novo consultor responsável para gerenciar esta carteira."
            headerIcon="mdi-account-switch-outline"
            footerActions={
                <>
                    <NeoButton 
                        variant="outline-chocolate" 
                        onClick={toggle} 
                        disabled={isTransferring}
                    >
                        Cancelar
                    </NeoButton>
                    <NeoButton
                        variant="warning"
                        onClick={handleConfirm}
                        disabled={!targetEmployeeId || isTransferring}
                        loading={isTransferring}
                        icon="mdi-check"
                    >
                        Confirmar Transferência
                    </NeoButton>
                </>
            }
        >
            <div className="text-center mb-4">
                <p className="text-muted font-size-14 mb-0">
                    Você está transferindo <strong className="text-dark">{selectedCount} cliente(s)</strong> de sua carteira ativa para outro consultor.
                </p>
            </div>

            <div>
                <NeoInput
                    type="select"
                    label="Consultor de Destino"
                    value={targetEmployeeId}
                    onChange={(e) => setTargetEmployeeId(e.target.value)}
                    disabled={isTransferring}
                    options={[
                        { value: "", label: "Selecione o novo consultor..." },
                        ...availableEmployees.map(emp => ({
                            value: emp.id,
                            label: emp.fullName || `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.email
                        }))
                    ]}
                />
            </div>
        </NeoModal>
    );
};

TransferModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    employees: PropTypes.array.isRequired,
    currentEmployeeId: PropTypes.string,
    selectedCount: PropTypes.number.isRequired,
    onConfirm: PropTypes.func.isRequired,
    isTransferring: PropTypes.bool
};

export default TransferModal;
